import { useMemo } from 'react';
import { Account, Feature, getFeatureFromPlan, PlanInterval } from '../../../models';
import { BOOLEAN_QUERY_PARAMS, PRODUCT_QUERY_PARAMS, TRACKING_QUERY_PARAMS } from '../../../utils/Constants';
import { useQuery } from '../../../routes';

type QueryParam = {
  [key: string]: any; // 👈️ variable key
};

export const useParseQueryParam = (selectedAccount?: Account): QueryParam => {
  const { get } = useQuery();
  const spEnabled = get('spEnabled') === 'true';
  const aod = get('route') === 'starter';
  const queryParam: QueryParam = {};

  if (spEnabled) {
    queryParam.sp = true;
  }

  if (aod) {
    queryParam.aod = true;
  }

  BOOLEAN_QUERY_PARAMS.forEach(param => {
    const prams = get(param) === 'true';
    if (prams) {
      queryParam[param] = true;
    }
  });

  PRODUCT_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      const feature = getFeatureFromPlan(param);
      const prefix = Feature.getFeaturePrefix(feature);
      const interval = PlanInterval.getIntervalFromPlanCode(param);
      queryParam[`${prefix}Quota`] = value;
      queryParam[`${prefix}Cycle`] = interval;
    }
  });
  TRACKING_QUERY_PARAMS.forEach(param => {
    const value = get(param);
    if (value) {
      queryParam[param] = value;
    }
  });
  return useMemo(
    () => {
      if (selectedAccount) {
        queryParam.accountId = selectedAccount?.id;
      }
      return queryParam;
    },
    [selectedAccount],
  );
};
